var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.606,
    height: 26.613,
    viewBox: "0 0 26.606 26.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.909,17.8a3.424,3.424,0,0,1,2.2-3.194,13.571,13.571,0,0,0-1.642-3.956,3.47,3.47,0,0,1-1.393.3,3.416,3.416,0,0,1-3.125-4.808A13.53,13.53,0,0,0,21,4.5a3.421,3.421,0,0,1-6.388,0,13.571,13.571,0,0,0-3.956,1.642,3.416,3.416,0,0,1-3.125,4.808,3.357,3.357,0,0,1-1.393-.3A13.871,13.871,0,0,0,4.5,14.616,3.423,3.423,0,0,1,4.507,21,13.571,13.571,0,0,0,6.149,24.96a3.417,3.417,0,0,1,4.511,4.511,13.65,13.65,0,0,0,3.956,1.642,3.414,3.414,0,0,1,6.374,0,13.571,13.571,0,0,0,3.956-1.642,3.421,3.421,0,0,1,4.511-4.511A13.65,13.65,0,0,0,31.1,21,3.44,3.44,0,0,1,28.909,17.8ZM17.865,23.339A5.543,5.543,0,1,1,23.408,17.8,5.541,5.541,0,0,1,17.865,23.339Z",
    transform: "translate(-4.5 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.67c1ba99.svg";
export { ForwardRef as ReactComponent };